import React from "react";
import { PickerMobile } from "../Picker";
import CurrencySign from "./CurrencySign";
import "./CurrencyPicker.types";
var CurrencyPickerMobile = function (props) {
    var children = props.children, currencySelection = props.currencySelection, selectedCurrencyId = props.selectedCurrencyId, shouldDisplaySelectionTitle = props.shouldDisplaySelectionTitle, attributes = props.attributes, triggerAttributes = props.triggerAttributes, onOpen = props.onOpen, onClose = props.onClose;
    var renderSign = function (item) {
        var active = item.id === selectedCurrencyId;
        return React.createElement(CurrencySign, { text: item.sign, active: active, mobile: true });
    };
    return (React.createElement(PickerMobile, { selection: currencySelection, selectedId: selectedCurrencyId, shouldDisplaySelectionTitle: shouldDisplaySelectionTitle, attributes: attributes, triggerAttributes: triggerAttributes, renderSign: renderSign, onOpen: onOpen, onClose: onClose }, children));
};
export default CurrencyPickerMobile;
